export default __webpack_public_path__ + "static/media/itnext-banner.b9062986.jpg";